<td *ngIf="!isProfile">
  <div *ngIf="!isInGroup">
    <mat-checkbox [checked]="!!row.checked" (change)="onCkboxToggle($event.checked)"></mat-checkbox>
  </div>
</td>
<td>{{ row.id }}</td>
<td>{{ row.jiraNumber ? row.jiraNumber : '-' }}</td>
<td>
  <div class="title"><mat-icon *ngIf="isFolder" class="folder-icon">folder</mat-icon>{{ row.title }}</div>
</td>
<td *ngIf="!isProfile">
  <div *ngIf="!isInGroup" class="options-container">
    <mat-icon #optionsBtn class="options" (click)="toggleMenu($event)">more_vert</mat-icon>
  </div>
</td>
<td>{{ row.status | uppercase }}</td>
<td *ngIf="!isProfile">{{ row.createBy }}</td>
<td>{{ row.createTs | momentToNow }}</td>
<td>
  <span *ngIf="row.assignedTo.length > 0" [matTooltip]="getAssignedToNames()" [matTooltipClass]="'tooltip'">
    {{ getAssignedToShortNames() }}
  </span>
  <span *ngIf="row.assignedTo.length === 0">-</span>
</td>
<td>
  {{ row.updateTs | dateWithFormat }}<br />
  {{ row.updateTs | date: 'hh:mm a' }}
</td>
<td>{{ row.countryName }}</td>
<td>{{ row.lobDesc }}</td>
<td>
  <span class="icon-attachment"><mat-icon *ngIf="row.hasAttachments">attachment</mat-icon></span>
  <span *ngIf="!row.hasAttachments"></span>
</td>
<td *ngIf="!isProfile">
  <mat-icon
    class="drag-handle"
    [ngClass]="{ dragged: isBeingDragged }"
    *ngIf="!isInGroup && sortEvent.sortBy === 'priority' && sortEvent.sortOrder < 0"
    pReorderableRowHandle
    >drag_handle
  </mat-icon>
</td>
<td>
  <a *ngIf="!isFolder" (click)="showTicketDetails(row.id, isInGroup)" l10nTranslate>admin.details</a>
  <a *ngIf="isFolder" (click)="onExpand()">
    <span *ngIf="!isExpanded" l10nTranslate>admin.show</span><span *ngIf="isExpanded" l10nTranslate>admin.hide</span></a
  >
</td>
<td *ngIf="isProfile">
  <span class="icon-deleteticket"
    ><mat-icon (click)="deleteTicket(index, row.id)" class="mat-icon-delete" svgIcon="trash-icon"></mat-icon
  ></span>
</td>
